
import * as THREE from "three";
import { webcadDefines } from ".";
import { ModelInfo } from "./View3dWebCadModelInfo";

export class SceneExtras {

    private modelInfo: any;

    constructor(private extras: any, private object: THREE.Object3D) {
        this.modelInfo = object.userData.modelInfo;
    }

    private getList() {
        const type = this.modelInfo.type;
        if (type.match(/fur/)) return this.extras.furniture;
        if (type.match(/equ/)) return this.extras.equipment;
        if (type.match(/ext/)) return this.extras.exterior;
        if (type.match(/lig/)) return this.extras.light;
        return undefined;
    }

    private setList(list: any): void {
        const type = this.modelInfo.type;
        if (type.match(/fur/)) this.extras.furniture = list;
        if (type.match(/equ/)) this.extras.equipment = list;
        if (type.match(/ext/)) this.extras.exterior = list;
        if (type.match(/lig/)) this.extras.light = list;
    }

    // itemLibにコード名が存在しているか
    private isItemLib(): boolean {
        return this.extras.itemLib.some(code => code == this.modelInfo.code);
    }

    // リストに存在しているか
    private isList(code: string): boolean {
        return this.getList().some(object => object.code == code);
    }

    private getObj() {
        const position = this.object.getWorldPosition(new THREE.Vector3());
        return {
            code: this.modelInfo.code,
            guid: this.modelInfo.uuid,
            idthreed: this.modelInfo.idthreed,
            layer: this.modelInfo.layer,
            name: this.modelInfo.name,
            reverse: this.modelInfo.reverse,
            translate: [position.x, position.y, position.z],
            rotation: [this.object.rotation.x, this.object.rotation.y, this.object.rotation.z],
            scale: [this.modelInfo.scaleX, this.modelInfo.scaleY, this.modelInfo.scaleZ],
            sub_type: this.modelInfo.subType,
            type: this.modelInfo.type,
        }
    }

    // アイテム追加時のextras更新
    public create(): void {
        this.debugprint();
        let list = this.getList();

        if (!list || list.length < 1) {
            if (this.modelInfo.typeExtras == webcadDefines.ExtrasType.FUR) {
                this.extras.furniture = [];
                this.extras.furniture.push(this.getObj());
            }
            if (this.modelInfo.typeExtras == webcadDefines.ExtrasType.EQU) {
                this.extras.equipment = [];
                this.extras.equipment.push(this.getObj());
            }
            if (this.modelInfo.typeExtras == webcadDefines.ExtrasType.EXT) {
                this.extras.exterior = [];
                this.extras.exterior.push(this.getObj());
            }
            if (this.modelInfo.typeExtras == webcadDefines.ExtrasType.LIGHT) {
                this.extras.light = [];
                this.extras.light.push(this.getObj());
            }
        }
        else {
            list.push(this.getObj());
            this.setList(list);
        }
        if (!this.isItemLib()) this.extras.itemLib.push(this.modelInfo.code);
        this.debugprint();
    }

    // アイテム移動時のextras更新
    public update(): void {
        let list = this.getList();
        if (!list || list.length < 1) return;
        const newList = list.map(obj => {
            if (this.modelInfo && obj.guid == this.modelInfo.uuid) {
                const position = this.object.getWorldPosition(new THREE.Vector3());
                obj.translate = [position.x, position.y, position.z];
                obj.rotation = [this.object.rotation.x, this.object.rotation.y, this.object.rotation.z];
                obj.scale = [this.object.scale.x, this.object.scale.y, this.object.scale.z];
                if (this.modelInfo.idthreed) {
                    obj.idthreed = this.modelInfo.idthreed;
                }
            }
            return obj;
        });
        this.setList(newList);
    }

    // アイテム削除時のextras更新
    public deleate(): void {
        this.debugprint();
        let list = this.getList();
        if (!list) return;
        const newList = list.filter(obj => this.modelInfo && obj.guid != this.modelInfo.uuid);
        this.setList(newList);
        if (this.isItemLib() && !this.isList(this.modelInfo.code)) this.extras.itemLib = this.extras.itemLib.filter(code => code != this.modelInfo.code);
        console.log(this.modelInfo.uuid);
        this.debugprint();
    }

    private debugprint() {
        console.log(JSON.parse(JSON.stringify(this.extras)));
    }
}
